import { useState, useCallback, useRef } from 'react';

export default function useContent(initial) {
  const originalRef          = useRef(initial);
  const [draft, setDraft]    = useState(initial);
  const [saving, setSaving]  = useState(false);
  const [lastSaved, setLast] = useState(null);
  const [error, setError]    = useState(null);

  const isDirty = JSON.stringify(draft) !== JSON.stringify(originalRef.current);

  const update = useCallback((patch) => {
    setDraft(prev => ({ ...prev, ...patch }));
  }, []);

  const save = useCallback(async (persistFn) => {
    setSaving(true);
    setError(null);
    try {
      await persistFn(draft);
      originalRef.current = draft;
      setLast(Date.now());
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }, [draft]);

  const discard = useCallback((original) => {
    originalRef.current = original;
    setDraft(original);
  }, []);

  return { draft, isDirty, update, save, discard, saving, lastSaved, error };
}
